import apiClient from "../../../utils/interceptor";
import inferenceClient from "../../../utils/inferenceInterceptor";
import {
  ApiResponse,
  CompanyConfig,
  GetCompanyConfigDetailsResponse,
  CreateCompanyConfigParams,
  UpdateCompanyConfigParams,
} from "./interface";
import { API_URLS } from "../../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

export const getCompanyConfigDetailsByCompanyId = async (
  company_id: string
): Promise<ApiResponse<GetCompanyConfigDetailsResponse[]>> => {
  try {
    const response = await apiClient.get<
      ApiResponse<GetCompanyConfigDetailsResponse[]>
    >(
      `${API_URLS.COMPANY_CONFIG.GET_COMPANY_CONFIG_DETAILS_BY_COMPANY_ID}/${company_id}`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching company configs:", error);
    throw error;
  }
};

export const getCompanyConfigById = async (
  id: string
): Promise<ApiResponse<CompanyConfig>> => {
  try {
    const response = await apiClient.get<ApiResponse<CompanyConfig>>(
      `${API_URLS.COMPANY_CONFIG.GET_COMPANY_CONFIG_BY_ID}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching company config by ID:", error);
    throw error;
  }
};

export const createCompanyConfig = async (
  data: CreateCompanyConfigParams
): Promise<ApiResponse<CompanyConfig>> => {
  try {
    const response = await apiClient.post<ApiResponse<CompanyConfig>>(
      API_URLS.COMPANY_CONFIG.CREATE_COMPANY_CONFIG,
      data,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating company config:", error);
    throw error;
  }
};

export const updateCompanyConfig = async (
  data: UpdateCompanyConfigParams
): Promise<ApiResponse<CompanyConfig>> => {
  try {
    const response = await apiClient.patch<ApiResponse<CompanyConfig>>(
      API_URLS.COMPANY_CONFIG.UPDATE_COMPANY_CONFIG,
      data,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating company config:", error);
    throw error;
  }
};

export const deleteCompanyConfig = async (
  company_config_id: string
): Promise<ApiResponse<null>> => {
  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      `${API_URLS.COMPANY_CONFIG.DELETE_COMPANY_CONFIG}`,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
        data: { company_config_id },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting company config:", error);
    throw error;
  }
};

export const clearRedisCache = async (): Promise<ApiResponse<null>> => {
  try {
    const flushCacheUrl = process.env.REACT_APP_FLUSH_REDIS_CACHE; 

    if (!flushCacheUrl) {
      throw new Error(
        "FLUSH_REDIS_CACHE_URL is not set in environment variables"
      );
    }
    const response = await inferenceClient.get<ApiResponse<null>>(
      flushCacheUrl,
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error Clearing Cache:", error);
    throw error;
  }
};
